<template>
  <div class="row">
    <b-container fluid>
      <b-card no-body>
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <div class="m-2">
            <b-row>
              <b-col cols="5">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      label-for="trainingSystemSelected"
                    >
                      <v-select
                        v-model="trainingSystemSelected"
                        :options="trainingSystems"
                        :reduce="(option) => option.value"
                        :disabled="!!$route.params.id"
                        :clearable="false"
                        placeholder="1.Chọn hệ đào tạo"
                        @input="onChangeTrainingSystem"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label-for="coursesSemestersSelected"
                    >
                      <v-select
                        v-model="coursesSemestersSelected"
                        :options="coursesSemestersOptions"
                        :reduce="(option) => option.value"
                        :disabled="!!$route.params.id"
                        :clearable="false"
                        placeholder="2.Chọn khóa - học kỳ"
                        @input="onChangeCoursesSemester"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="7">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      title="Dự kiến thi"
                      label-for="examinationScheduler"
                    >
                      <v-select
                        v-model="examinationSchedulerSelect"
                        :options="examinationSchedulers"
                        :reduce="(option) => option.id"
                        label="name"
                        placeholder="3. Dự kiến thi"
                        @input="onChangeExaminationScheduler"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      label-for="creditClassSelected"
                    >
                      <v-select
                        v-model="creditClassSelected"
                        :options="creditClasses"
                        :reduce="(option) => option.value"
                        :disabled="!!$route.params.id"
                        :clearable="false"
                        placeholder="4.Chọn lớp độc lập"
                        @input="onChangeCreditClasses"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <validation-observer
              ref="studentExaminationPointManualFormRef"
              #default="{invalid}"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="3"
                  lg="3"
                  xl="2"
                >
                  <b-form-group>
                    <v-select
                      v-model="filter.examTimes"
                      :options="examTimeTypes"
                      :reduce="(option) => option.value"
                      label="text"
                      placeholder="Lần thi"
                      @input="onSelectStudentExaminationRoom"
                    />
                  </b-form-group>
                </b-col>
                <b-col
                  cols="12"
                  md="9"
                  lg="9"
                  xl="10"
                >
                  <div class="text-right">
                    <b-button
                      v-show="filter.creditClassId > 0"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="success"
                      class="mr-1"
                      @click="onSelectStudentExaminationRoom"
                    >
                      <span
                        class="text-nowrap text-right"
                      ><feather-icon icon="ListIcon" /> Danh sách sinh viên</span>
                    </b-button>
                    <b-button
                      v-show="saveScoreShowAble"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      :disabled="invalid"
                      class="mr-1"
                      variant="primary"
                      @click="onSave(scoreByCreditClass)"
                    >
                      <span class="text-nowrap text-right">
                        <feather-icon icon="CheckIcon" /> Lưu lại
                      </span>
                    </b-button>
                    <b-dropdown
                      v-show="saveScoreShowAble"
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      text="Nhập file"
                      right
                      variant="outline-primary"
                    >
                      <b-dropdown-item @click="downloadFile">
                        <span class="text-nowrap text-right">
                          <feather-icon icon="DownloadIcon" /> Tải về file mẫu
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item @click="$refs.inputFileRef.$el.click()">
                        <span class="text-nowrap text-right">
                          <feather-icon icon="UploadIcon" /> Tải lên file
                        </span>
                      </b-dropdown-item>
                      <b-form-file
                        ref="inputFileRef"
                        accept=".xls, .xlsx"
                        :hidden="true"
                        plain
                        @change="importExcel"
                      />
                    </b-dropdown>
                  </div>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12">
                  <vue-good-table
                    mode="remote"
                    :columns="columns"
                    :rows="scoreByCreditClass"
                    :pagination-options="paginationOptions"
                    :line-numbers="true"
                    class="my-table"
                    style-class="my-table vgt-table striped bordered"
                  >
                    <div
                      slot="emptystate"
                      style="text-align: center; font-weight: bold"
                    >
                      Không có bản ghi nào !
                    </div>
                    <template
                      slot="table-row"
                      slot-scope="props"
                    >
                      <span v-if="props.column.field === 'score'">
                        <validation-provider
                          #default="{ errors }"
                          rules="required|between:0,10"
                          name="Điểm"
                        >
                          <b-form-input
                            v-model="props.row.score"
                            :tabindex="props.row.originalIndex + 1"
                            @change="
                              changeCell(
                                props.row.score,
                                props.column.field,
                                props.row.originalIndex
                              )
                            "
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </span>
                      <span v-else-if="props.column.field === 'note'">
                        <b-form-input
                          v-model="props.row.note"
                          type="text"
                          @change="
                            changeCell(
                              props.row.note,
                              props.column.field,
                              props.row.originalIndex
                            )
                          "
                        />
                      </span>
                      <!-- Column: Common -->
                      <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                    </template>
                  </vue-good-table>
                </b-col>
              </b-row>
            </validation-observer>
          </div>
        </b-overlay>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BFormGroup,
  BOverlay,
  BRow,
  BFormInput,
  BDropdownItem,
  BFormFile,
  BDropdown,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-good-table.scss'
import Ripple from 'vue-ripple-directive'
import * as XLSX from 'xlsx'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { between, required } from '@core/utils/validations/validations'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import { OrganizationCode, PermissionCode, ResourceCode } from '@/const/code'
import { getUser } from '@/auth/utils'
import apiMain from '@/views/examination-room-batch/api'
import apiSchedulerBatch from '@/views/examination-scheduler-batch/api'
import { Workbook } from '@syncfusion/ej2-excel-export'
import { showErrorToast, showSuccessToast, showWarningToast } from '@/utils/notification'

export default {
  name: 'StudentExaminationPointManual',
  directives: {
    Ripple,
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    BDropdown,
    BFormFile,
    BDropdownItem,
    BButton,
    BFormGroup,
    BCard,
    BCol,
    BContainer,
    BOverlay,
    BRow,
    VueGoodTable,
    vSelect,
    BFormInput,
  },
  data() {
    return {
      user: getUser(),
      trainingSystemSelected: undefined,
      coursesSemestersSelected: undefined,
      creditClassSelected: undefined,
      subjectsSelected: undefined,
      examinationSchedulerSelect: null,
      examinationSchedulers: [],
      isLoading: false,
      filter: {
        creditClassId: this.$route.params.id || 0,
        examTimes: 1,
      },
      paginationOptions: {
        enabled: false,
      },
      columns: [
        {
          label: 'Mã sinh viên',
          field: 'code',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Họ tên',
          field: 'name',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-right',
        },
        {
          label: 'Điểm bằng số',
          field: 'score',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
        {
          label: 'Ghi chú',
          field: 'note',
          sortable: false,
          thClass: 'text-center',
          tdClass: 'text-center',
        },
      ],
      required,
      between,
      creditClasses: [],
      examTimeTypes: [
        { value: 1, text: 'Thi lần 1' },
        { value: 2, text: 'Thi lần 2' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      trainingSystems: 'dropdown/trainingSystems',
      scoreByCreditClass: 'studentExaminationRoom/scoreByCreditClass',
      examinationRoomSubjects: 'studentExaminationRoom/examinationRoomSubjects',
      coursesSemesters: 'studentExaminationRoom/coursesSemesters',
      subjects: 'studentExaminationRoom/subjects',
    }),
    coursesSemestersOptions() {
      return this.coursesSemesters.map(item => ({
        value: item.id,
        label: item.name,
      }))
    },
    saveScoreShowAble() {
      return this.scoreByCreditClass.length > 0 && this.filter.creditClassId
    },
    creditClassCode() {
      const found = this.creditClasses.find(element => element.value === this.creditClassSelected)
      if (found) return found.label
      return ''
    },
    examinationPointUpdatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.MANUAL_EXAMINATION_POINT)
    },
    isCdyteLa() {
      return getUser().orgCode === OrganizationCode.CAO_DANG_Y_TE_LONG_AN
    },
  },
  async created() {
    this.isLoading = true
    try {
      const [numberOfRetakeExam, response2] = await Promise.all([
        apiMain.getSystemParameterByCode('NUMBER_OF_RETAKE_EXAM'),
        this.getTrainingSystems(),
      ])
      if (numberOfRetakeExam === '3') {
        this.examTimeTypes.push({ value: 3, text: 'Thi lần 3' })
      }
      if (this.$route.params.id > 0) {
        await this.getScoreByCreditClass(this.filter)
      } else {
        this.reset()
      }
    } catch (e) {
      this.showToast(`[${e.code}] ${e.message}`, 'XCircleIcon', 'danger')
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    ...mapMutations({
      setScoreByCreditClass: 'studentExaminationRoom/SET_SCORE_BY_CREDIT_CLASS',
    }),
    ...mapActions({
      getTrainingSystems: 'dropdown/getTrainingSystems',
      getScoreByCreditClass: 'studentExaminationRoom/getScoreByCreditClass',
      getCoursesSemesters: 'studentExaminationRoom/getCoursesSemesters',
      getSubjects: 'studentExaminationRoom/getSubjects',
      getExaminationRoomSubjects: 'studentExaminationRoom/getExaminationRoomSubjects',
      saveScoresByCode: 'studentExaminationRoom/saveScoresByCode',
      getCreditClasses: 'dropdown/getCreditClasses',
    }),
    async onChangeTrainingSystem() {
      this.isLoading = true
      try {
        this.reset()
        this.coursesSemestersSelected = null
        this.creditClassSelected = null
        this.subjectsSelected = null
        if (this.trainingSystemSelected == null) {
          this.$store.commit('studentExaminationRoom/SET_COURSESSEMESTERS', { data: [] })
          this.$store.commit('studentExaminationRoom/SET_EXAMINATIONROOMSUBJECTS', { data: [] })
          this.$store.commit('studentExaminationRoom/SET_SUBJECT', { data: [] })
        } else {
          await this.getCoursesSemesters({
            organizationId: getUser().orgId,
            training_system_id: this.trainingSystemSelected,
          })
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async onChangeCoursesSemester() {
      this.isLoading = true
      try {
        this.reset()
        this.subjectsSelected = null
        this.creditClassSelected = null
        if (this.coursesSemestersSelected) {
          this.examinationSchedulers = await apiMain.getExaminationSchedulers({ courseSemesterId: this.coursesSemestersSelected, currentPage: 1, itemsPerPage: 1000000 })
        } else {
          this.examinationSchedulers = []
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async onChangeExaminationScheduler() {
      this.isLoading = true
      try {
        this.creditClassSelected = null
        this.reset()
        if (this.examinationSchedulerSelect) {
          const data = await apiSchedulerBatch.getCreditClassesByScheduler({ examinationSchedulerId: this.examinationSchedulerSelect })
          this.creditClasses = this.isCdyteLa
            ? data.map(element => ({ value: element.id, label: `${element.name} - ${element.classCode}` }))
            : data.map(element => ({ value: element.id, label: `${element.name} - ${element.code}` }))
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async onChangeCreditClasses() {
      if (this.creditClassSelected == null) {
        this.reset()
      } else {
        this.filter.creditClassId = this.creditClassSelected
        await this.onSelectStudentExaminationRoom()
      }
    },

    reset() {
      this.filter.creditClassId = 0
      this.setScoreByCreditClass({ records: [] })
    },

    async onSelectStudentExaminationRoom() {
      this.isLoading = true
      try {
        await this.getScoreByCreditClass(this.filter)
        if (this.scoreByCreditClass.length === 0) {
          showWarningToast(this, 'Vui lòng tạo phòng thi trước!')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    changeCell(data, column, row) {
      this.scoreByCreditClass[row][column] = data
    },

    async onSave(data) {
      if (!this.examinationPointUpdatable) {
        showWarningToast(this, 'Bạn phải có quyền nhập điểm thi hoặc là giáo viên của lớp')
        return
      }
      if (data.some(element => element.score === null || element.score === undefined)) {
        showWarningToast(this, 'Vui lòng nhập đầy đủ dữ liệu điểm')
        return
      }
      if (data.some(element => isNaN(element.score))) {
        showWarningToast(this, 'Vui lòng nhập đúng kiểu dữ liệu điểm!')
        return
      }
      if (data.some(element => element.score < 0 || element.score > 10)) {
        showWarningToast(this, 'Điểm chỉ được nằm trong khoảng từ 0 đến 10!')
        return
      }

      this.isLoading = true
      const scoresByCode = data.map(element => ({
        id: element.id,
        score: element.score !== null && element.score !== undefined ? element.score : null,
        note: element.note || null,
        examinationRoomId: element.examinationRoomId,
        studentCreditClassId: element.studentCreditClassId,
      }))
      try {
        const response = await apiMain.saveScoresByCreditClass({
          scoresByCode,
          examinationSchedulerId: this.examinationSchedulerSelect,
          courseSemesterId: this.coursesSemestersSelected,
          creditClassId: this.filter.creditClassId,
          examTimes: this.filter.examTimes,
        })
        if (response) {
          const { isSuccessful, message } = response
          if (isSuccessful) {
            showSuccessToast(this, message)
            await this.getScoreByCreditClass(this.filter)
          } else {
            showErrorToast(this, message)
          }
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async downloadFile() {
      const columns = [
        { index: 1, width: 80 },
        { index: 2, width: 200 },
        { index: 3, width: 200 },
        { index: 4, width: 150 },
        { index: 5, width: 300 },
        { index: 6, width: 150 },
        { index: 7, width: 150 },
      ]
      const rows = []
      const headerRow = {
        index: 1,
        cells: [
          {
            index: 1,
            value: 'ID',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 2,
            value: 'Mã phòng thi',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 3,
            value: 'Mã lớp của học viên',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 4,
            value: 'Mã học viên',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 5,
            value: 'Tên học viên',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 6,
            value: 'Điểm',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
          {
            index: 7,
            value: 'Ghi chú',
            style: {
              borders: {
                color: '#00000000',
                lineStyle: 'thin',
              },
              hAlign: 'center',
              vAlign: 'center',
              fontColor: '#000000',
              backColor: '#FFFFFF',
              bold: true,
              wrapText: true,
              fontSize: 13,
              fontName: 'Times New Roman',
            },
          },
        ],
      }

      rows.push(headerRow)
      const dataAll = this.scoreByCreditClass || []
      dataAll.forEach((data, index) => {
        const newRow = {
          index: index + 2,
          cells: [
            {
              index: 1,
              value: data.id,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'center',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 2,
              value: data.examinationRoomId,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'right',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 3,
              value: data.studentCreditClassId,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'right',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 4,
              value: data.code,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'left',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 5,
              value: data.name,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'left',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 6,
              value: (data.score !== null && data.score !== undefined && data.score !== '')
                ? Number(data.score).toString().replace(',', '.')
                : '',
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'right',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
            {
              index: 7,
              value: data.note,
              style: {
                borders: {
                  color: '#00000000',
                  lineStyle: 'thin',
                },
                hAlign: 'left',
                vAlign: 'center',
                wrapText: true,
                fontSize: 13,
                fontName: 'Times New Roman',
              },
            },
          ],
        }
        rows.push(newRow)
      })

      const worksheets = [{ columns, rows, name: 'scores' }]
      const workbook = new Workbook({ worksheets }, 'xlsx')
      workbook.save(`NhapDiemThiLopDocLap_${this.creditClassCode}.xlsx`)
    },
    importExcel(e) {
      const { files } = e.target
      if (files.length === 0) {
        showWarningToast(this, 'File dữ liệu đang bị trống')
        return false
      }
      if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        showWarningToast(this, 'File đầu vào phải có kiểu định dạng xlsx hoặc xls')
        return false
      }
      const fileReader = new FileReader()
      fileReader.addEventListener(
        'load',
        async ev => {
          const { result } = ev.target
          const workbook = XLSX.read(result, { type: 'binary' })
          const wsName = workbook.SheetNames[0]
          const data = XLSX.utils.sheet_to_json(workbook.Sheets[wsName])
          const mappedData = data.map(row => ({
            id: row.ID,
            examinationRoomId: row['Mã phòng thi'],
            studentCreditClassId: row['Mã lớp của học viên'],
            studentCode: row['Mã học viên'],
            studentName: row['Tên học viên'],
            score: row['Điểm'],
            note: row['Ghi chú'],
          }))
          if (mappedData.length > 0) {
            await this.onSave(mappedData)
          } else {
            showWarningToast(this, 'File không có dữ liệu')
          }
          this.resetInputFile()
        },
        false,
      )
      fileReader.readAsBinaryString(files[0])
      return true
    },

    resetInputFile() {
      this.$refs.inputFileRef.reset()
    },
  },

  beforeRouteUpdate(to, from, next) {
    // Call the API query method when the URL changes
    this.reset()
    next()
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
